'use client';

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
} from '@ui/components';
import { Trash, Ellipsis, Pencil } from 'lucide-react';
import { Button } from '@ui/components/ui/button';

interface TopicItemMenuProps {
  onDelete: (e: React.MouseEvent<HTMLDivElement>) => void;
  onEdit?: (e: React.MouseEvent<HTMLDivElement>) => void;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const TopicItemMenu: React.FC<TopicItemMenuProps> = ({
  onDelete,
  onEdit,
  isOpen,
  onOpenChange,
}) => {
  return (
    <DropdownMenu open={isOpen} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="ghost" className="rounded">
          <Ellipsis />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-40" hideWhenDetached>
        <DropdownMenuGroup>
          {onEdit && (
            <DropdownMenuItem onClick={onEdit} className="space-x-2 cursor-pointer">
              <Pencil className="h-4 w-4 mr-2" />
              <span>Edit</span>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={onDelete} className="text-red-500 space-x-2 cursor-pointer">
            <Trash className="h-4 w-4 mr-2" />
            <span>Delete</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
